"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEducationInfoById = exports.getEducationAdmin = exports.getAllEducationList = exports.educationList = exports.educationEdit = exports.educationDel = exports.educationAdd = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 描述 获取教育局列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var educationList = exports.educationList = function educationList(data) {
  return _api.default.request({
    url: '/bureau/bureauList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取所有教育局列表
 * @author whz
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getAllEducationList = exports.getAllEducationList = function getAllEducationList(data) {
  return _api.default.request({
    url: '/bureau/bureauAllList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增教育局
 * @author kkdy 
 * @date 2021-12-09
 * @param {any} data
 * @returns {any}
 */
var educationAdd = exports.educationAdd = function educationAdd(data) {
  return _api.default.request({
    url: "/bureau/saveBureau",
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据id获取教育局信息
 * @author kkdy
 * @date 2022-01-13
 * @param {any} data
 * @returns {any}
 */
var getEducationInfoById = exports.getEducationInfoById = function getEducationInfoById(data) {
  return _api.default.request({
    url: "/bureau/oneBureau",
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑教育局
 * @author kkdy
 * @date 2021-12-09
 * @param {any} data
 * @returns {any}
 */
var educationEdit = exports.educationEdit = function educationEdit(data) {
  return _api.default.request({
    url: "/bureau/editBureau",
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除教育局
 * @author kkdy
 * @date 2021-12-09
 * @param {any} data
 * @returns {any}
 */
var educationDel = exports.educationDel = function educationDel(data) {
  return _api.default.request({
    url: "/bureau/removeBureau",
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取教育局下的管理员
 * @author kkdy
 * @date 2021-12-09
 * @param {any} data
 * @returns {any}
 */
var getEducationAdmin = exports.getEducationAdmin = function getEducationAdmin(data) {
  return _api.default.request({
    url: "/bureau/bureauAdmins",
    method: 'post',
    data: data
  });
};